import ManageGoalTable from './ManageGoalTable'

const ManageGoalType = {
  Table: ManageGoalTable,
}

export default ManageGoalType
